class Design {
    constructor(config) {
        this.name = config.name;
    }


    getName() {
        return this.name;
    }

    setName(name) {
        this.name = name;
    }
}   

